import React, { useState } from 'react';
import { CollectionComponent, UiComponent } from 'components';
import { useIsMobile, usePageOption } from 'hooks';
import { CollectionQuery } from 'queries';
import { SearchCollectionsFilterType } from 'types';

function DesktopList() {
  const pageState = usePageOption();
  const [filter, setFilter] = useState<SearchCollectionsFilterType>({});
  const { data } = CollectionQuery.useGetAll({
    page: pageState.pageOption.page,
    size: pageState.pageOption.size,
    ...filter,
  });

  return (
    <CollectionComponent.List
      toolbar={
        <CollectionComponent.Filter filter={filter} handleFilter={setFilter} />
      }
      {...pageState}
      totalPage={data?.totalPage}
      data={data?.data || []}
    />
  );
}

function List() {
  const isMobile = useIsMobile();

  const title = <UiComponent.PageTitle>컬렉션 관리</UiComponent.PageTitle>;

  if (isMobile) return <CollectionComponent.MobileList title={title} />;

  return (
    <>
      {title}
      <DesktopList />
    </>
  );
}

export default List;
